import React from 'react';
import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../theme/Theme';
import { Image } from 'antd';
import ImgAboutUs from '../assets/nfts/about-us.png';
import ImgAboutUs2 from '../assets/nfts/about-us-2.png';
import ImgAboutUs3 from '../assets/nfts/about-us-3.png';

const Wrapper = styled.div`
    width: 100%;
    .body {
        margin: 0 auto;
        max-width: 871px;
        padding: 40px 20px;
        display: flex;
        flex-direction: row;
        .image-about-us {
            text-align: center;
        }
        .left {
            flex: 1;
            .large-title {
                font-family: 'Karmatic Arcade';
                font-style: normal;
                font-weight: 400;
                font-size: 40px;
                line-height: 56px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #000000;
            }
            .small-title {
                font-family: 'Joystix';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 32px;
                color: #585858;
                margin-top: 50px;
            }
        }
        .right {
            flex: 1;
            display: flex;
            justify-content: right;
            align-item: center;
            .ant-image {
                max-width: 611px;
            }
        }
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .body {
            flex-direction: column;
            .right {
                justify-content: center;
            }
            .large-title {
                font-size: 38px !important;
            }
            .small-title {
                font-style: normal;
                font-weight: 400;
                font-size: 16px !important;
                line-height: 36px;
                margin-top: 50px;
            }
            img {
                margin-top: 25px;
            }
        }
    }
`;

const AboutUs = () => {
    return (
        <Wrapper>
            <div className="body">
                <div className="left">
                    <p className="large-title">About BPunkClub</p>
                    <p className="small-title">
                        At the heart of BPunks lies the groundbreaking technology of Trustless Computer, enabling
                        developers to write smart contracts directly on the Bitcoin blockchain. This game-changing
                        advancement has paved the way for a fusion of the beloved dapps you know and love with the
                        unparalleled security and immutability of Bitcoin.
                    </p>
                    <div className="image-about-us">
                        <Image style={{ marginTop: `50px` }} preview={false} src={ImgAboutUs} />
                    </div>
                    <p className="small-title">
                        Imagine a world where NFTs, DeFi, Payments, Gaming, DAOs, file storage, and a multitude of other
                        decentralized applications seamlessly exist within the Bitcoin ecosystem. BPunks is spearheading
                        this charge, granting its esteemed members an exclusive ticket to this exhilarating journey. But
                        what truly sets BPunks apart is its dynamic and inclusive governance model. As a BPunk holder,
                        you become an integral part of a decentralized autonomous organization (DAO), where your voice
                        holds power, decisions are made collectively, and future benefits await.
                    </p>
                    <p className="small-title">
                        Within the BPunks DAO, members come together to shape the destiny of this digital utopia. Your
                        insights, ideas, and expertise will fuel the evolution of the project, and together, you will
                        unlock a wealth of possibilities. Participate in strategic discussions, propose new initiatives,
                        and shape the very fabric of the BPunks ecosystem.
                    </p>
                    <div className="image-about-us">
                        <Image preview={false} src={ImgAboutUs3} />
                    </div>
                    <p className="small-title">
                        The future is bright for BPunks holders, as the DAO rewards your loyalty and active involvement.
                        Exclusive airdrops, early access to groundbreaking features, preferential access to limited
                        editions, and even the chance to collaborate with top-tier artists and developers are just a
                        glimpse of the benefits that await you.
                    </p>
                    <div className="image-about-us">
                        <Image style={{ marginTop: `50px` }} preview={false} src={ImgAboutUs2} />
                    </div>
                    <p className="small-title">
                        This is not just a club; it&apos;s a movement. A movement powered by the unparalleled security,
                        transparency, and immutability of Bitcoin. Join the ranks of BPunks and become part of a
                        community that dares to redefine what&apos;s possible on the world&apos;s most trusted
                        blockchain.
                    </p>
                    <p className="small-title">
                        Are you ready to unleash the true potential of Bitcoin? Buckle up, as the BPunks revolution is
                        just getting started.{' '}
                    </p>
                </div>
            </div>
        </Wrapper>
    );
};

export default AboutUs;
